<script lang="ts">
  import Post from '$lib/components/homepage/Post/Post.svelte';
  import SkeletonPost from '$lib/components/common/skeletons/SkeletonPost.svelte';
  import type { WithCreatorData } from 'garden-common';
  import type { FPost } from 'garden-common';
  import { createEventDispatcher } from 'svelte';
  import { inview } from 'svelte-inview';

  const dispatch = createEventDispatcher<{ reachedEnd: never | undefined }>();

  export let posts: (FPost<string> & WithCreatorData)[] = [];
  export let failed: boolean;
  export let exhausted: boolean;
  export let forYouItemCount: number;
  export let lastPostContainer: HTMLElement;

  function onReachedEnd() {
    dispatch('reachedEnd');
  }
</script>

<div class="gap-y-4 flex flex-col w-full flex-grow overflow-scroll scrollbar-hide">
  {#if posts.length !== 0}
    {#each posts as post, index}
      {#if index === forYouItemCount}
        <div class="flex my-4 items-center">
          <div class="bg-gray-300 h-[2px] flex-grow" />
          <span class="text-gray-400 px-4 font-medium">Explore posts</span>
          <div class="bg-gray-300 h-[2px] flex-grow" />
        </div>
      {/if}

      <div bind:this={lastPostContainer} class="overflow-visible">
        <Post {post} />
      </div>
    {/each}
  {/if}

  {#if !exhausted}
    <span use:inview on:inview_enter={onReachedEnd}>
      <SkeletonPost />
    </span>

    <SkeletonPost />
  {/if}

  <div class="font-bold text-center w-full text-gray-400 mt-16 h-80">
    {#if failed}
      Load failed.
    {:else if exhausted}
      No more posts to show.
    {:else if posts.length === 0}
      No posts to show.
    {/if}
  </div>
</div>
